import {
    createContext,
    useContext
} from "react";
import type {
    ToggleGroupContextType
} from "./type";

export const ToggleGroupContext = createContext<ToggleGroupContextType | undefined>(undefined);

export const useToggleGroupContext = (): ToggleGroupContextType | undefined => {
    return useContext(ToggleGroupContext);
};
